import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, ASSETS } from '../data/site';

// Central SEO component: manages title, meta description, canonical,
// Open Graph / Twitter cards, hreflang and optional JSON-LD structured data.
const SEO = ({ title, description, path = '/', lang = 'de', image, jsonLd, keywords }) => {
  const url = `${SITE_URL}${path === '/' ? '/' : path}`;
  const img = image || ASSETS.powderPile;
  const imgAbs = img.startsWith('http') ? img : `${SITE_URL}${img}`;
  const fullTitle = title ? `${title} | metakaolin.info` : 'metakaolin.info – Metakaolin knowledge platform by Newchem GmbH';
  // Only allow indexing on the real live domain; block preview/staging hosts.
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const isLive = host === 'www.metakaolin.info' || host === 'metakaolin.info';
  const robots = isLive ? 'index, follow, max-image-preview:large' : 'noindex, nofollow';

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="metakaolin.info" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imgAbs} />
      <meta property="og:locale" content={lang === 'de' ? 'de_AT' : 'en_US'} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imgAbs} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default SEO;
